import { Dispatch, SetStateAction, useState } from 'react';

/**
 * Parses entityField value to defaultFiles prop value.
 * @param {string | number | readonly string[] | undefined} value
 * @returns {string[]}
 * Array of strings.
 */
function parseDefaultFiles(
  value: string | number | readonly string[] | undefined,
): string[] {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  } else {
    return [value as string];
  }
}

export interface UseFileInputDefaultFiles {
  defaultValues: string[];
  setDefaultValues: Dispatch<SetStateAction<string[]>>;
  handleRemoveExistingFile: (index: number) => void;
}

export function useFileInputDefaultFiles(
  value: string | number | readonly string[] | undefined,
  isMultiple: boolean,
): UseFileInputDefaultFiles {
  const [defaultValues, setDefaultValues] = useState<string[]>(
    parseDefaultFiles(value),
  );

  function handleRemoveExistingFile(index: number) {
    if (isMultiple) {
      setDefaultValues(defaultValues.filter((_file, i) => i !== index));
    } else {
      setDefaultValues([]);
    }
  }

  return {
    defaultValues,
    setDefaultValues,
    handleRemoveExistingFile,
  };
}
